import { useState, useEffect } from 'react';
import styled from 'styled-components';
import {
    Box,
    Dialog,
    DialogContent,
    Typography,
    IconButton,
    Tooltip
} from '@mui/material';
import { AddPhotoAlternateOutlined } from '@mui/icons-material';
import { apiUrl } from '../utils/common';
import axios from 'axios';
import Spinner from './Spinner';

const ImageContainer = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 6px;
  object-fit: cover;
  cursor: pointer;

`;

const MemeSelector = ({ onSelect, selectedMemeUrl, convertToEmbeddableUrl }) => {
    const [memes, setMemes] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [isMemeSelected, setIsMemeSelected] = useState(false);
    const [loading, setLoading] = useState(false);
    
    const openModal = async () => {
        setLoading(true);
        const data = await fetchMemes();
        setIsOpen(true);
        setMemes(data);
        setLoading(false);
    };

    const fetchMemes = async () => {
        try {
            const res = await axios.get(`${apiUrl}/driveDocs/getDriveMeme`);
            return res.data;
        } catch (error) {
            console.error('Error fetching memes:', error);
            return [];
        }
    };

    const closeModal = () => {
        setIsOpen(false);
    };

    useEffect(() => {
        if (!selectedMemeUrl) {
            setIsMemeSelected(false);
        }
        else {
            setIsMemeSelected(true);
        }
    }, [selectedMemeUrl]);

    return (
        <div>
            {loading && <Spinner />}
            {!isMemeSelected &&  !loading && (
                <Tooltip title="Add MEME" PopperProps={{
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, -20],
                            },
                        },
                    ],
                }}>
                    <IconButton onClick={openModal} aria-label="Add MEME">
                        <AddPhotoAlternateOutlined fontSize="large" color="primary" />
                    </IconButton>
                </Tooltip>
            )}
            <Dialog open={isOpen} onClose={closeModal} maxWidth='xs'>
                <DialogContent style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Typography variant="h6" gutterBottom>SELECT A MEME</Typography>
                    <Box display="flex" flexWrap="wrap" gap={1} justifyContent="center">
                        {memes.length === 0 ? (
                            <Typography variant="body2">No memes found.</Typography>
                        ) : (
                            memes.map((meme, index) => (
                                <ImageContainer
                                    key={index}
                                    src={convertToEmbeddableUrl(meme.url)}
                                    alt={meme.name}
                                    onClick={() => {
                                        onSelect(meme.url);
                                        setIsMemeSelected(true);
                                        closeModal();
                                    }}
                                />
                            ))
                        )}
                    </Box>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default MemeSelector;
